import React, { Fragment, useState } from 'react';

import BtnSlider from '../BtnSlider';

import PartnerCard, { SC } from './PartnerCard';

const FeaturedPartners = ({ featured }) => {
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(6);
  const totalFeatured = featured?.length;

  const nextSlide = () => {
    setStart(start + 1);
    setEnd(end + 1);
  };

  const prevSlide = () => {
    setStart(start - 1);
    setEnd(end - 1);
  };

  return (
    <div className="text-center">
      <h2>Featured Partners</h2>
      {totalFeatured > 0 && (
        <SC.PartnerWrapper count={totalFeatured > 6}>
          <div className="slider featured">
            {featured.slice(start, end).map((slide) => (
              <PartnerCard partner={slide} key={slide.id} />
            ))}
            {totalFeatured > 6 && (
              <Fragment>
                <BtnSlider
                  testid="prev-slide"
                  moveSlide={prevSlide}
                  direction={'prev'}
                  disabled={start === 0}
                />
                <BtnSlider
                  testid="next-slide"
                  moveSlide={nextSlide}
                  direction={'next'}
                  disabled={end === totalFeatured}
                />
              </Fragment>
            )}
          </div>
        </SC.PartnerWrapper>
      )}
    </div>
  );
};

export default FeaturedPartners;
